export default "__VITE_ASSET__$MTNUBm9__"